import React from 'react';
import { ErrorMessage } from 'react-hook-form';


const funcName = ({errors, name}) => (
    <div className='form-error'>
        <ErrorMessage errors={errors} name={name} />
    </div>
);

export default funcName;